import { useUserSettings } from "@next-platform/client-common-core";
import { useState } from "react";

import useShouldFilterNsfwCharacters from "@/components/search/hooks/useShouldFilterNsfwCharacters";
import { NSFW_TOGGLE_LOCALSTORAGE_KEY } from "@/constants";
import { typedLocalStorageService } from "@/utils/localStorageRe";

/**
 * Effective NSFW browse selection for Discover. Matches Home: stored toggle plus
 * capabilities and user settings. The shared controller reloads when this changes.
 */
const useDiscoverNsfwSelection = (): boolean => {
  const { showNSFW } = useUserSettings();
  const [stateIsNsfwToggled] = useState(() => typedLocalStorageService.getItem(NSFW_TOGGLE_LOCALSTORAGE_KEY) === "true");
  const { shouldFilterNsfwCharacters } = useShouldFilterNsfwCharacters({
    isNsfwToggled: stateIsNsfwToggled,
    isShowNsfwEnabled: showNSFW,
  });

  return !shouldFilterNsfwCharacters;
};

export default useDiscoverNsfwSelection;
